import typeaheadSingleView from './typeaheadSingleComponent.html';
import './typeaheadSingleComponent.css';
import _ from 'lodash';
import { ensure } from 'components/sharpr/ensure/ensure';
import { filterObjects } from '../../matchesAllWords/matchesAllWords.js';

export function typeaheadSingleComponent() {
	return {
		bindings: {
			model: '=',
			items: '<?',
			provider: '<?',
			placeholder: '@?',
			minChars: '<?',
			maxItems: '<?',
			emptyVals: '=?',
			emptyPrompt: '@?',
			debounce: '=?',
			onChoose: '&?',
			clearOnFocus: '<?',
		},
		controllerAs: 'vm',
		controller: typeaheadSingleComponentCtrl,
		template: typeaheadSingleView,
	};
}

class typeaheadSingleComponentCtrl {
	constructor($element, $scope, $timeout) {
		'ngInject';
		// save injections
		this.$timeout = $timeout;
		this.input = $element.find('input')[0];
		// setup
		$scope.$watch('vm.model', this.filter.bind(this));
		$element.find('input').on('keydown', this.handleKeydown.bind(this));
		// default values
		this.debounce = this.debounce === undefined ? 150 : this.debounce;
		this.model = this.model || '';
	}

	// bound by watching vm.model
	filter(newVal, oldVal) {
		if (newVal === oldVal || !this.isFocused) {
			return;
		}
		if (this.model === '') {
			this.suggestions = this.emptyVals || [];
			this.showingEmptyVals = true;
			return;
		}
		this.showingEmptyVals = false;
		if (_.isFunction(this.provider)) {
			// provider should return an array or a promise that returns an array
			ensure.promise(this.provider(this.input.value)).then(suggestions => {
				this.$timeout(() => {
					this.suggestions = ensure.array(suggestions).slice(0, this.maxItems || Infinity);
				});
			});
		} else if (_.isArray(this.items)) {
			this.suggestions = filterObjects(this.items, this.model, ['$search'], this.maxItems);
		}
	}

	// bound by ng-focus
	handleFocus() {
		this.activeItem = null;
		this.isFocused = true;
		if (this.clearOnFocus) {
			this.oldModel = this.model;
			this.model = '';
		}
		// send query so that newVal does not equal oldVal
		this.filter(this.model);
	}

	// bound by ng-blur
	handleBlur() {
		this.isFocused = false;
		if (this.clearOnFocus && this.oldModel && this.model === '') {
			this.model = this.oldModel;
		}
		this.suggestions = [];
	}

	// bound by angular.element().on('keydown')
	handleKeydown(evt) {
		let key = evt.which;
		if (key == 27) {
			// escape key
			evt.target.blur();
			return;
		}
		if ([13, 38, 40].indexOf(key) === -1) {
			// not return, up, or down so do nothing
			return;
		}
		if (key == 13 && !this.activeItem) {
			// let enter bubble up to form, then blur
			setTimeout(() => evt.target.blur(), 250);
			return;
		}
		evt.preventDefault();
		if (key == 13 && this.activeItem) {
			// return key to choose item
			evt.target.blur();
			this.chooseItem(this.activeItem);
		} else if (key == 38) {
			// up key - if the index is out of bounds, this.activeItem will become undefined which is good
			this.activeItem = this.suggestions[this.suggestions.indexOf(this.activeItem) - 1];
		} else if (key == 40) {
			// down key - if the index is out of bounds, this.activeItem will become undefined
			this.activeItem = this.suggestions[this.suggestions.indexOf(this.activeItem) + 1];
		}
		// run digest so activeItem applies
		this.$timeout(() => {});
	}

	// fired on key enter or on ng-click
	chooseItem(item) {
		this.oldModel = null;
		this.activeItem = item;
		this.handleBlur();
		// $choice is a special injection that the parent can specify
		this.onChoose && this.onChoose({ $choice: item });
	}
}
